import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1468.23529,113 L1468.23529,212.388235 L1355.29412,325.329412 L1355.29412,225.941176 L112.941176,225.941176 L112.941176,1694.17647 L1355.29412,1694.17647 L1355.29412,1255.96471 L1468.23529,1143.02353 L1468.23529,1807.11765 L0,1807.11765 L0,113 L1468.23529,113 Z M421.270588,1163.35294 C517.270588,1154.31765 576,1271.77647 612.141176,1361 C640.376471,1429.89412 650.541176,1453.61176 684.423529,1457 C718.305882,1460.38824 773.647059,1398.27059 797.364706,1355.35294 C813.894264,1328.84327 848.78445,1320.7528 875.294118,1337.28235 C901.803786,1353.81191 909.894264,1388.7021 893.364706,1415.21176 C884.329412,1432.15294 800.752941,1575.58824 687.811765,1575.58824 L687.811765,1575.58824 L678.776471,1575.58824 C608.752941,1571.07059 556.8,1527.02353 509.364706,1409.56471 C461.929412,1292.10588 431.435294,1281.94118 431.435294,1281.94118 C380.174711,1347.63097 346.721038,1425.43021 334.305882,1507.82353 C327.756435,1539.01137 297.164315,1558.98474 265.976471,1552.43529 C234.788626,1545.88585 214.815258,1515.29373 221.364706,1484.10588 C241.694118,1389.23529 300.423529,1173.51765 421.270588,1163.35294 Z M677.647059,677.705882 L677.647059,790.647059 L338.823529,790.647059 L338.823529,677.705882 L677.647059,677.705882 Z M903.529412,451.823529 L903.529412,564.764706 L338.823529,564.764706 L338.823529,451.823529 L903.529412,451.823529 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1903.05882,468.764706 L1677.17647,242.882353 C1666.57318,232.191756 1652.13953,226.178448 1637.08235,226.178448 C1622.02517,226.178448 1607.59153,232.191756 1596.98824,242.882353 L919.341176,920.529412 C909.115192,931.138347 903.440895,945.324088 903.528392,960.058824 L903.528392,1242.41176 L1185.88235,1242.41176 C1200.77756,1242.1996 1214.98557,1236.11045 1225.41176,1225.47059 L1903.05882,547.823529 C1924.58219,525.865308 1924.58219,490.722928 1903.05882,468.764706 Z M1162.16471,1129.47059 L1016.47059,1129.47059 L1016.47059,983.776471 L1468.23529,532.011765 L1613.92941,677.705882 L1162.16471,1129.47059 Z M1694.11765,597.517647 L1548.42353,451.823529 L1637.64706,362.6 L1783.34118,508.294118 L1694.11765,597.517647 Z"
}));

var IconAnnotateLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAnnotateLine, _Component);

  var _super = _createSuper(IconAnnotateLine);

  function IconAnnotateLine() {
    _classCallCheck(this, IconAnnotateLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAnnotateLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAnnotate",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAnnotateLine.displayName = "IconAnnotateLine";
  return IconAnnotateLine;
}(Component);

IconAnnotateLine.glyphName = 'annotate';
IconAnnotateLine.variant = 'Line';
IconAnnotateLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAnnotateLine;
export { IconAnnotateLine };